import { InvoiceStateModel } from '~backoffice/app/~shared/models/store.models';
import {
  CreateInvoiceParams,
  Invoice,
  LineItem
} from '~core/models/invoice.models';

export class ResetState {
  static readonly type = '[Invoice] Reset State';
  constructor(public data?: Partial<InvoiceStateModel>) {}
}

export class InitDraftInvoice {
  static readonly type = '[Invoice] Init Draft Invoice';
  constructor(public data: Invoice) {}
}

export class InitCertifiedInvoice {
  static readonly type = '[Invoice] Init Certified Invoice';
  constructor(public data: Invoice) {}
}

export class PatchDraftInvoice {
  static readonly type = '[Invoice] Patch Draft Invoice';
  constructor(public data: Partial<Invoice>) {}
}

export class PatchInvoiceLine {
  static readonly type = '[Invoice] Patch Invoice Line';
  constructor(public data: LineItem) {}
}

export class RemoveInvoiceLine {
  static readonly type = '[Invoice] Remove Invoice Line';
  constructor(public data: number | string) {}
}

export class CalculateInvoiceAmounts {
  static readonly type = '[Invoice] Calculate Invoice Amounts';
  constructor(public lineItems?: LineItem[]) {}
}

export class CreateInvoiceDraft {
  static readonly type = '[Invoice] Create Invoice Draft';
  constructor(public data: CreateInvoiceParams) {}
}
